module.exports = __webpack_public_path__ + "static/media/arrow-right.c47f65fa.svg";